import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbButtonModule } from '@nebular/theme';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [CommonModule, NbButtonModule],
  template: `
    <ng-container *ngIf="showBanner">
      <ng-container *ngTemplateOutlet="banner; context: { $implicit: 'cookie-banner' }"></ng-container>
      <!-- Same-size copy in page flow, so the fixed banner never covers the end of the page. -->
      <ng-container *ngTemplateOutlet="banner; context: { $implicit: 'cookie-banner-spacer' }"></ng-container>
    </ng-container>
    <ng-template #banner let-cls>
      <div [class]="cls" [attr.aria-hidden]="cls === 'cookie-banner-spacer' || null">
        <span>We use cookies to ensure you get the best experience on our website.</span>
        <button nbButton status="primary" (click)="acceptCookies()" [attr.tabindex]="cls === 'cookie-banner-spacer' ? -1 : null">Got it!</button>
      </div>
    </ng-template>
  `,
  styles: [`
    .cookie-banner, .cookie-banner-spacer {
      padding: 1rem;
      background: #000000;
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
    }
    .cookie-banner {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1000;
    }
    .cookie-banner-spacer {
      visibility: hidden;
    }
  `]
})
export class CookieComponent implements OnInit {
  showBanner = true;

  ngOnInit() {
    const cookieAccepted = localStorage.getItem('cookieConsent');
    this.showBanner = !cookieAccepted;
  }

  acceptCookies() {
    localStorage.setItem('cookieConsent', 'true');
    this.showBanner = false;
  }
}
